import { UtthungaHeader } from "@/components/utthunga/UtthungaHeader";
import { DomainSection } from "@/components/chevron/DomainSection";
import { utthungaDomains } from "@/data/utthunga/utthungaDomains";
import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
import TeamMembersGrid from "@/components/ispai/TeamMembersGrid";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useState } from 'react';
import { InviteColleagueDialog } from "@/components/InviteColleagueDialog";

const UTTHUNGA_CHANNEL_ID = "a1b2c3d4-e5f6-4789-abcd-ef0123456789";

// Team members are fetched dynamically from user_organizations via channelId
const utthungaTeamMembers: { image: string; alt: string }[] = [];

const networkStats = {
  totalParticipants: 0,
  activeContributors: 0,
  knowledgeBases: 0,
  totalSolutions: 0,
  departments: [
    { name: "Product Engineering", participants: 0 },
    { name: "Industrial Solutions", participants: 0 },
    { name: "Industrial IoT", participants: 0 },
    { name: "IT-OT Integration", participants: 0 },
    { name: "Security Engineering", participants: 0 }
  ]
};

const UtthungaChannel = () => {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  
  // Fetch knowledge bases with domain associations for this channel
  const { data: domainKBs } = useQuery({
    queryKey: ['utthunga-channel-kbs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('knowledge_base_domains')
        .select(`
          knowledge_base_id,
          domain_id,
          domains(name, symbol),
          knowledge_bases!inner(
            id,
            title,
            status,
            deleted_at,
            creator_id
          )
        `)
        .eq('knowledge_bases.status', 'published')
        .is('knowledge_bases.deleted_at', null);
      
      if (error) throw error;
      return data;
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <UtthungaHeader />
        
        <TeamMembersGrid 
          members={utthungaTeamMembers} 
          useProfileAvatars={true}
          showAskCurt={false}
          channelId={UTTHUNGA_CHANNEL_ID}
        />

        <Card className="mb-12 p-6">
          <CardContent className="p-0">
            <h2 className="text-xl font-semibold mb-4">Dashboard</h2>
            <KnowledgeNetworkStats {...networkStats} channelName="utthunga" />
          </CardContent>
        </Card>
        
        <DomainSection 
          title="Utthunga Domains" 
          domains={utthungaDomains} 
          titleColor="text-black" 
          domainKBs={domainKBs} 
        />

        {/* Invite Dialog */}
        <InviteColleagueDialog
          open={inviteDialogOpen}
          onOpenChange={setInviteDialogOpen}
          defaultChannelId={UTTHUNGA_CHANNEL_ID}
          defaultChannelName="Utthunga"
        />
      </div>
    </div>
  );
};

export default UtthungaChannel;
